import { render, staticRenderFns } from "./AiAdmin.vue?vue&type=template&id=7641b366&scoped=true"
import script from "./AiAdmin.vue?vue&type=script&lang=js"
export * from "./AiAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7641b366",
  null
  
)

export default component.exports